// Copyright 2026, Auxilio Technologies LLC

import {
  HomeIcon,
  TruckIcon,
  MapIcon,
  ChartBarIcon,
  BuildingOfficeIcon,
  ExclamationTriangleIcon,
  Cog6ToothIcon,
  EyeIcon,
  CalendarDaysIcon,
  UserGroupIcon,
  UsersIcon,
  ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline';
import { Permissions, PermissionType } from './rolesConfig';

export interface NavItem {
  name: string;
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  permission?: PermissionType;
}

export interface NavCategory {
  name: string;
  items: NavItem[];
}

export const navigationConfig: NavCategory[] = [
  {
    name: 'Overview',
    items: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        icon: HomeIcon,
        permission: Permissions.DASHBOARD_READ,
      },
      {
        name: 'Control Tower',
        path: '/control-tower',
        icon: EyeIcon,
        permission: Permissions.CONTROL_TOWER_READ,
      },
    ],
  },
  {
    name: 'Operations',
    items: [
      {
        name: 'Shipments',
        path: '/shipments',
        icon: TruckIcon,
        permission: Permissions.SHIPMENTS_READ,
      },
      {
        name: 'Route Optimization',
        path: '/routes',
        icon: MapIcon,
        permission: Permissions.ROUTES_READ,
      },
      {
        name: 'Alerts',
        path: '/alerts',
        icon: ExclamationTriangleIcon,
        permission: Permissions.ALERTS_READ,
      },
    ],
  },
  {
    name: 'Planning',
    items: [
      {
        name: 'Forecasting',
        path: '/forecasting',
        icon: CalendarDaysIcon,
        permission: Permissions.FORECASTING_READ,
      },
    ],
  },
  {
    name: 'Governance',
    items: [
      {
        name: 'Supplier Scorecard',
        path: '/suppliers',
        icon: UserGroupIcon,
        permission: Permissions.SUPPLIERS_READ,
      },
      {
        name: 'Analytics',
        path: '/analytics',
        icon: ChartBarIcon,
        permission: Permissions.ANALYTICS_READ,
      },
    ],
  },
  {
    name: 'Administration',
    items: [
      {
        name: 'Sites',
        path: '/sites',
        icon: BuildingOfficeIcon,
        permission: Permissions.SITES_READ,
      },
      {
        name: 'User Management',
        path: '/admin/users',
        icon: UsersIcon,
        permission: Permissions.USERS_READ,
      },
      {
        name: 'Settings',
        path: '/settings',
        icon: Cog6ToothIcon,
        permission: Permissions.SETTINGS_READ,
      },
      {
        name: 'Feedback',
        path: '/feedback',
        icon: ChatBubbleLeftRightIcon,
        // No permission required - all users can submit feedback
      },
    ],
  },
];
